<template>
  <b-modal
    id="modal-categorias"
    centered
    size="xl"
    hide-footer
    class="modal-categorias"
    title="Resumen por Categoría"
  >
    <div>
      <!-- Selector de meses -->
      <div class="mes-selector-grid mb-0">
        <b-row>
          <b-col
            v-for="mes in mesesDisponibles"
            :key="mes.value"
            cols="1"
            class="mb-2 text-center"
          >
            <b-button
              :variant="
                mesesSeleccionados.includes(mes.value)
                  ? 'primary'
                  : 'outline-secondary'
              "
              block
              style="font-size: 12px"
              @click="toggleMes(mes.value)"
            >
              {{ mes.text }}
            </b-button>
          </b-col>
        </b-row>
      </div>

      <div class="d-flex align-items-center mb-3">
        <b-button
          size="sm"
          variant="secondary"
          @click="toggleTodasLasCategoriasGlobal"
        >
          <i :class="
              todasDesplegadasGlobal
                ? 'fas fa-chevron-up mr-1'
                : 'fas fa-chevron-down mr-1'
            "
          ></i>
          {{ todasDesplegadasGlobal ? "Colapsar todas" : "Desplegar todas" }}
        </b-button>

        <div class="ml-auto">
          <b-button variant="outline-primary" @click="imprimirTablaAuto">
            Imprimir PDF
          </b-button>
        </div>
      </div>

      <!-- Tabla de ingresos -->
      <div ref="tablaIngesos">
        <b-table
          :items="tablaFiltradaIngresos"
          :fields="fieldsIngresos"
          :tbody-tr-class="rowClassConTotal"
          responsive
          thead-class="thread-categorias"
        >
          <!-- Flecha expandir solo para filas de categoría -->
          <template #cell(toggle)="data">
            <b-button
              v-if="data.item.isCategoria && data.item.permiteSubitems"
              size="sm"
              variant="light"
              class="toggle-categoria-btn"
              @click="
                visibilidadIngresos[data.item.categoria] =
                  !visibilidadIngresos[data.item.categoria]
              "
            >
              <i
                :class="
                  visibilidadIngresos[data.item.categoria]
                    ? 'fas fa-chevron-up'
                    : 'fas fa-chevron-down'
                "
              ></i>
            </b-button>
          </template>

          <template #cell(categoria)="data">
            <span v-if="data.item.isCategoria">
              <strong>{{ data.item.categoria }}</strong>
            </span>
            <span v-else>
              {{ data.item.nombre }}
            </span>
          </template>

          <!-- Columnas de cada mes -->
          <template
            v-for="mes in mesesSeleccionados"
            v-slot:[`cell(${mes})`]="{ item }"
          >
            <div class="text-right">
              {{ formatoEspanol(item[mes]) }}
            </div>
          </template>

          <!-- Total -->
          <template #cell(total)="data">
            <div class="text-right">
              {{ formatoEspanol(data.item.total) }}
            </div>
          </template>
        </b-table>
      </div>

      <!-- Tabla de categorías -->
      <div ref="tablaCategorias">
        <b-table
          :items="tablaFiltrada"
          :fields="fields"
          :tbody-tr-class="rowClassConTotal"
          responsive
          thead-class="thread-categorias"
        >
          <!-- Flecha expandir solo para filas de categoría -->
          <template #cell(toggle)="data">
            <b-button
              v-if="data.item.isCategoria && data.item.permiteSubitems"
              size="sm"
              variant="light"
              class="toggle-categoria-btn"
              @click="
                visibilidadCategorias[data.item.categoria] =
                  !visibilidadCategorias[data.item.categoria]
              "
            >
              <i
                :class="
                  visibilidadCategorias[data.item.categoria]
                    ? 'fas fa-chevron-up'
                    : 'fas fa-chevron-down'
                "
              ></i>
            </b-button>
          </template>

          <template #cell(categoria)="data">
            <span v-if="data.item.isCategoria">
              <strong>{{ data.item.categoria }}</strong>
            </span>
            <span v-else>
              {{ data.item.nombre }}
            </span>
          </template>

          <!-- Columnas de cada mes -->
          <template
            v-for="mes in mesesSeleccionados"
            v-slot:[`cell(${mes})`]="{ item }"
          >
            <div class="text-right">
              {{ formatoEspanol(item[mes]) }}
            </div>
          </template>

          <!-- Total -->
          <template #cell(total)="data">
            <div class="text-right">
              {{ formatoEspanol(data.item.total) }}
            </div>
          </template>
        </b-table>
      </div>

      <!-- Tabla de totales -->
      <div ref="tablaTotales">
        <b-table
          :items="tablaTotales"
          :fields="fieldsTotales"
          :tbody-tr-class="rowClass"
          responsive
          thead-class="thread-categorias"
        >
          <!-- Columnas de cada mes -->
          <template
            v-for="mes in mesesSeleccionados"
            v-slot:[`cell(${mes})`]="{ item }"
          >
            <div class="text-right">
              {{ formatoEspanol(item[mes]) }}
            </div>
          </template>

          <!-- Total -->
          <template #cell(total)="data">
            <div class="text-right">
              {{ formatoEspanol(data.item.total) }}
            </div>
          </template>
        </b-table>
      </div>

      <!-- Botón para imprimir -->
      <div class="text-right mt-3">
        <b-button variant="outline-primary" @click="imprimirTablaAuto"
          >Imprimir PDF</b-button
        >
      </div>
    </div>
  </b-modal>
</template>

<script src="https://unpkg.com/jspdf@3.0.1/dist/jspdf.node.min.js"></script>
<script src="https://unpkg.com/jspdf-autotable@5.0.2/dist/jspdf.plugin.autotable.js"></script>

<script>
import html2canvas from "html2canvas";

const { jsPDF } = window.jspdf;

/*import { jsPDF } from 'jspdf'
import { autoTable } from 'jspdf-autotable'*/

export default {
  props: ["items"],
  data() {
    return {
      mesesSeleccionados: [],
      mesesDisponibles: this.generarMeses(),
      visibilidadCategorias: {},
      visibilidadIngresos: {},
    };
  },
  computed: {
    todasDesplegadasGlobal() {
      const desplegadasIngresos = this.tablaFiltradaIngresos
        .filter((item) => item.isCategoria && item.permiteSubitems)
        .every((item) => this.visibilidadIngresos[item.categoria]);

      const desplegadasCategorias = this.tablaFiltrada
        .filter((item) => item.isCategoria && item.permiteSubitems)
        .every((item) => this.visibilidadCategorias[item.categoria]);

      return desplegadasIngresos && desplegadasCategorias;
    },
    tablaFiltradaIngresos() {
      const resultados = [];
      const agrupado = {};

      //return [];

      //this.mesesSeleccionados.sort((a, b) => a.localeCompare(b));

      const itemsFiltrados = this.items.filter((item) =>
        this.mesesSeleccionados.includes(item.value)
      );

      //Ordenes
      this.mesesSeleccionados.forEach((mes) => {
        const itemMes = itemsFiltrados.find((i) => i.value === mes);

        const nombreCategoria = "Ordenes";

        if (!agrupado[nombreCategoria]) {
          agrupado[nombreCategoria] = {
            isCategoria: true,
            categoria: nombreCategoria,
            detalles: {},
            permiteSubitems: false,
          };

          // registrar visibilidad si no existe
          if (!(nombreCategoria in this.visibilidadIngresos)) {
            this.$set(this.visibilidadIngresos, nombreCategoria, false); //esto sera false
          }

          this.mesesSeleccionados.forEach((m) => {
            agrupado[nombreCategoria][m] = 0;
            agrupado[nombreCategoria].detalles[m] = [];
          });
        }

        agrupado[nombreCategoria][mes] +=
          itemMes.datosResumenMes.gananciaTotalDiaria;
        agrupado[nombreCategoria].detalles[mes].push([]);
      });

      //Facturas Positivas
      this.mesesSeleccionados.forEach((mes) => {
        const itemMes = itemsFiltrados.find((i) => i.value === mes);
        const dias = itemMes?.dias || [];

        dias.forEach((dia) => {
          if (
            dia.facturasPositivas === undefined ||
            dia.facturasPositivas.total === 0
          )
            return;

          const facturaClienteExterno = dia.facturasPositivas.items.some(
            (factura) => factura.idCliente !== 6
          );

          if (!facturaClienteExterno) return;

          const nombreCategoria = "Facturas";

          if (!agrupado[nombreCategoria]) {
            agrupado[nombreCategoria] = {
              isCategoria: true,
              categoria: nombreCategoria,
              detalles: {},
              permiteSubitems: true,
            };

            // registrar visibilidad si no existe
            if (!(nombreCategoria in this.visibilidadIngresos)) {
              this.$set(this.visibilidadIngresos, nombreCategoria, false); //esto sera false
            }

            this.mesesSeleccionados.forEach((m) => {
              agrupado[nombreCategoria][m] = 0;
              agrupado[nombreCategoria].detalles[m] = [];
            });
          }

          const facturasFiltradas = (dia.facturasPositivas.items || []).filter(
            (f) => f.idCliente !== 6
          );

          if (facturasFiltradas.length > 0) {
            const totalFiltrado = facturasFiltradas.reduce(
              (sum, f) => sum + parseFloat(f.total || 0),
              0
            );

            agrupado[nombreCategoria][mes] += totalFiltrado;
            agrupado[nombreCategoria].detalles[mes].push(...facturasFiltradas);
          }

          /*agrupado[nombreCategoria][mes] += parseFloat(
            dia.facturasPositivas.total
          );
          agrupado[nombreCategoria].detalles[mes].push(
            ...(dia.facturasPositivas.items || [])
          );*/
        });
      });

      //console.log(agrupado['Facturas']);

      // Construir estructura final con subfilas
      for (const cat in agrupado) {
        const item = agrupado[cat];
        item.total = this.mesesSeleccionados.reduce(
          (acc, mes) => acc + (item[mes] || 0),
          0
        );
        resultados.push(item); // fila categoría

        // Agregar subitems si visibilidad activa
        if (this.visibilidadIngresos[item.categoria]) {
          const subItemsMap = {};

          this.mesesSeleccionados.forEach((mes) => {
            const detallesMes = item.detalles[mes] || [];
            detallesMes.forEach((sub) => {
              const nombre = sub.codigo + " - " + sub.cliente;
              if (!subItemsMap[nombre]) {
                subItemsMap[nombre] = {
                  isCategoria: false,
                  nombre,
                  total: 0,
                };
                this.mesesSeleccionados.forEach(
                  (m) => (subItemsMap[nombre][m] = 0)
                );
              }

              const valor =
                typeof sub.total === "number"
                  ? sub.total
                  : this.parseEuro(sub.total);

              subItemsMap[nombre][mes] += valor;
              subItemsMap[nombre].total += valor;
            });
          });

          Object.values(subItemsMap).forEach((subItem) =>
            resultados.push(subItem)
          );
        }
      }

      const filaTotal = {
        isCategoria: true,
        categoria: "TOTAL",
        total: 0,
        permiteSubitems: false,
        ultima: true,
      };
      this.mesesSeleccionados.forEach((mes) => {
        filaTotal[mes] = resultados.reduce(
          (acc, item) => acc + (item[mes] || 0),
          0
        );
        filaTotal.total += filaTotal[mes];
      });

      resultados.push(filaTotal);

      return resultados;
    },
    tablaFiltrada() {
      const resultados = [];
      const agrupado = {};

      this.mesesSeleccionados.sort((a, b) => a.localeCompare(b));

      const itemsFiltrados = this.items.filter((item) =>
        this.mesesSeleccionados.includes(item.value)
      );

      this.mesesSeleccionados.forEach((mes) => {
        const itemMes = itemsFiltrados.find((i) => i.value === mes);
        const categorias = itemMes?.categoriasCalculadas || [];

        categorias.forEach((categoriaObj) => {
          const nombreCategoria = categoriaObj.categoria;

          if (!agrupado[nombreCategoria]) {
            agrupado[nombreCategoria] = {
              isCategoria: true,
              categoria: nombreCategoria,
              detalles: {},
              permiteSubitems: true,
            };

            // registrar visibilidad si no existe
            if (!(nombreCategoria in this.visibilidadCategorias)) {
              this.$set(this.visibilidadCategorias, nombreCategoria, false); //esto sera false
            }

            this.mesesSeleccionados.forEach((m) => {
              agrupado[nombreCategoria][m] = 0;
              agrupado[nombreCategoria].detalles[m] = [];
            });
          }

          agrupado[nombreCategoria][mes] += categoriaObj.precio;
          agrupado[nombreCategoria].detalles[mes].push(
            ...(categoriaObj.items || [])
          );
        });
      });

      //Return
      this.mesesSeleccionados.forEach((mes) => {
        const itemMes = itemsFiltrados.find((i) => i.value === mes);
        const dias = itemMes?.dias || [];

        dias.forEach((dia) => {
          if (
            dia.ordenesRefund === undefined ||
            dia.ordenesRefund.total === "0.00"
          )
            return;

          const nombreCategoria = "Return";

          if (!agrupado[nombreCategoria]) {
            agrupado[nombreCategoria] = {
              isCategoria: true,
              categoria: nombreCategoria,
              detalles: {},
              permiteSubitems: false,
            };

            // registrar visibilidad si no existe
            if (!(nombreCategoria in this.visibilidadIngresos)) {
              this.$set(this.visibilidadIngresos, nombreCategoria, false); //esto sera false
            }

            this.mesesSeleccionados.forEach((m) => {
              agrupado[nombreCategoria][m] = 0;
              agrupado[nombreCategoria].detalles[m] = [];
            });
          }

          agrupado[nombreCategoria][mes] += Math.abs(
            parseFloat(dia.ordenesRefund.total)
          );
          agrupado[nombreCategoria].detalles[mes].push(
            ...(dia.ordenesRefund.items || [])
          );
        });
      });

      //console.log(agrupado['Impuestos']);

      // Construir estructura final con subfilas
      Object.keys(agrupado)
        .sort((a, b) => a.localeCompare(b))
        .forEach((cat) => {
          const item = agrupado[cat];
          item.total = this.mesesSeleccionados.reduce(
            (acc, mes) => acc + (item[mes] || 0),
            0
          );
          resultados.push(item); // fila categoría

          // Agregar subitems si visibilidad activa
          if (this.visibilidadCategorias[item.categoria]) {
            const subItemsMap = {};

            this.mesesSeleccionados.forEach((mes) => {
              const detallesMes = item.detalles[mes] || [];
              detallesMes.forEach((sub) => {
                const nombre = sub.nombre;
                if (!subItemsMap[nombre]) {
                  subItemsMap[nombre] = {
                    isCategoria: false,
                    nombre,
                    total: 0,
                  };
                  this.mesesSeleccionados.forEach(
                    (m) => (subItemsMap[nombre][m] = 0)
                  );
                }

                const valor =
                  typeof sub.total === "number"
                    ? sub.total
                    : this.parseEuro(sub.total);

                subItemsMap[nombre][mes] += valor;
                subItemsMap[nombre].total += valor;
              });
            });

            Object.values(subItemsMap).forEach((subItem) =>
              resultados.push(subItem)
            );
          }
        });

      const filaTotal = {
        isCategoria: true,
        categoria: "TOTAL",
        total: 0,
        permiteSubitems: false,
        ultima: true,
      };

      this.mesesSeleccionados.forEach((mes) => {
        const sumaMes = resultados.reduce((acc, row) => {
          // Solo sumar filas de categoría (no subitems)
          return row.isCategoria ? acc + (row[mes] || 0) : acc;
        }, 0);

        filaTotal[mes] = sumaMes;
        filaTotal.total += sumaMes;
      });

      resultados.push(filaTotal);

      return resultados;
    },
    tablaTotales() {
      const fila = {
        categoria: "TOTAL GENERAL",
        total: 0,
      };

      // Inicializar cada mes en 0
      this.mesesSeleccionados.forEach((mes) => {
        fila[mes] = 0;
      });

      // Filtrar y acumular
      const itemsFiltrados = this.items.filter((item) =>
        this.mesesSeleccionados.includes(item.value)
      );

      itemsFiltrados.forEach((item) => {
        const mes = item.value;
        const importe = parseFloat(item.importe || 0);
        fila[mes] += importe;
        fila.total += importe;
      });

      return [fila]; // Solo una fila total
    },

    fields() {
      return [
        { key: "categoria", label: "Gastos" },
        ...this.mesesSeleccionados.map((mes) => ({
          key: mes,
          label: this.formatMonth(mes),
          class: "text-right",
        })),
        { key: "total", label: "Total", class: "text-right" },
        {
          key: "toggle",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { width: "10px" },
        },
      ];
    },
    fieldsIngresos() {
      return [
        { key: "categoria", label: "Ingresos" },
        ...this.mesesSeleccionados.map((mes) => ({
          key: mes,
          label: this.formatMonth(mes),
          class: "text-right",
        })),
        { key: "total", label: "Total", class: "text-right" },
        {
          key: "toggle",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { width: "10px" },
        },
      ];
    },
    fieldsTotales() {
      return [
        { key: "categoria", label: "" },
        ...this.mesesSeleccionados.map((mes) => ({
          key: mes,
          label: this.formatMonth(mes),
          class: "text-right",
        })),
        { key: "total", label: "Total", class: "text-right" },
        {
          key: "toggle",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { width: "10px" },
        },
      ];
    },
  },
  methods: {
    toggleTodasLasCategoriasGlobal() {
      const nuevoEstado = !this.todasDesplegadasGlobal;

      // Ingresos
      this.tablaFiltradaIngresos.forEach((item) => {
        if (item.isCategoria && item.permiteSubitems) {
          this.$set(this.visibilidadIngresos, item.categoria, nuevoEstado);
        }
      });

      // Categorías normales
      this.tablaFiltrada.forEach((item) => {
        if (item.isCategoria && item.permiteSubitems) {
          this.$set(this.visibilidadCategorias, item.categoria, nuevoEstado);
        }
      });
    },
    generarMeses() {
      const meses = [];
      const monthNames = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      const start = new Date(2025, 0, 1);
      const today = new Date();
      const startYear = start.getFullYear();
      const startMonth = start.getMonth();
      const endYear = today.getFullYear();
      const endMonth = today.getMonth();
      const diffMonths =
        (endYear - startYear) * 12 + (endMonth - startMonth) + 1;
      const totalMonths = Math.min(diffMonths, 24);

      for (let i = 0; i < totalMonths; i++) {
        const date = new Date(startYear, startMonth + i, 1);
        const value = `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, "0")}`;
        const text = `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
        meses.push({ value, text });
      }

      return meses;
    },
    toggleMes(valor) {
      const index = this.mesesSeleccionados.indexOf(valor);
      if (index >= 0) {
        this.mesesSeleccionados.splice(index, 1);
      } else {
        this.mesesSeleccionados.push(valor);
      }
    },
    formatoEspanol(valor) {
      if (!valor || valor === 0) return "-";
      return (
        new Intl.NumberFormat("es-ES", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valor) + " €"
      );
    },
    imprimirTablaAuto() {
      const horientacion = this.fields.length > 7 ? "landscape" : "portrait";
      const doc = new jsPDF(horientacion);

      // ------------------ TÍTULOS GENERALES ------------------
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text(
        "Ingresos y Gastos Mensuales",
        doc.internal.pageSize.getWidth() / 2,
        10,
        { align: "center" }
      );

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text("Harber London", doc.internal.pageSize.getWidth() / 2, 16, {
        align: "center",
      });

      // ------------------ TABLA INGRESOS ------------------
      const headers2 = this.fieldsIngresos
        .slice(0, -1)
        .map((f) => f.label || f.key);
      let data2 = [];
      this.tablaFiltradaIngresos.forEach((item) => {
        const row = [];
        this.fieldsIngresos.forEach((field) => {
          if (field.key === "toggle") return;
          if (field.key === "categoria") row.push(item["categoria"] || item["nombre"] || "-")
          else row.push(this.formatoEspanol(item[field.key]) || "-");
        });
        data2.push(row);
      });

      const columnStyles = {};
        headers2.forEach((_, i) => {
          columnStyles[i] = { cellWidth: '100' }; // puedes usar también un número fijo si lo prefieres
        });

      doc.autoTable({
        startY: 20,
        head: [headers2],
        body: data2,
        styles: { fontSize: 8, cellPadding: 3 },
        headStyles: {
          fontSize: 10,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          minCellHeight: 10,
          lineColor: [0, 0, 0],
          lineWidth: { top: 0.2, bottom: 0.2, left: 0, right: 0 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 20 },
        didParseCell: function (data) {
          const lastRowIndex = data.table.body.length - 1;

          if (data.row.index === lastRowIndex) {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fillColor = [80, 80, 80]; // gris oscuro
            data.cell.styles.textColor = [255, 255, 255]; // blanco
            data.cell.styles.lineWidth = { top: 0.75 }; // borde superior más grueso
            data.cell.styles.lineColor = [0, 0, 0];
          }
        },
      });

      // Calculamos posición final para poner la tabla de gastos debajo
      const finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 40;

      // ------------------ TABLA GASTOS ------------------
      const headers1 = this.fields.slice(0, -1).map((f) => f.label || f.key);
      let data1 = [];
      this.tablaFiltrada.forEach((item) => {
        const row = [];
        this.fields.forEach((field) => {
          if (field.key === "toggle") return;
          if (field.key === "categoria") {
            row.push(item.isCategoria ? item.categoria : "   " + item.nombre);
          } else {
            row.push(this.formatoEspanol(item[field.key]) || "-");
          }
        });
        data1.push(row);
      });

      doc.autoTable({
        startY: finalY,
        head: [headers1],
        body: data1,
        styles: { fontSize: 8, cellPadding: 3 },
        headStyles: {
          fontSize: 10,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          minCellHeight: 10,
          lineColor: [0, 0, 0],
          lineWidth: { top: 0.2, bottom: 0.2, left: 0, right: 0 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 20 },
        didParseCell: function (data) {
          const lastRowIndex = data.table.body.length - 1;

          if (data.row.index === lastRowIndex) {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fillColor = [80, 80, 80]; // gris oscuro
            data.cell.styles.textColor = [255, 255, 255]; // blanco
            data.cell.styles.lineWidth = { top: 0.75 }; // borde superior más grueso
            data.cell.styles.lineColor = [0, 0, 0];
          }
        },
      });

      // ------------------ TABLA TOTALES POR MES ------------------
      const finalY2 = doc.lastAutoTable.finalY + 10;
      const totales = this.tablaTotales; // genera el array [{ categoria, 2025-01, 2025-02, ..., total }]
      const headersTotales = [
        "",
        ...this.mesesSeleccionados.map((mes) => this.formatMonth(mes)),
        "Total",
      ];

      const bodyTotales = totales.map((item) => {
        const row = [];
        row.push(item.categoria);
        this.mesesSeleccionados.forEach((mes) =>
          row.push(this.formatoEspanol(item[mes]) || "-")
        );
        row.push(this.formatoEspanol(item.total) || "-");
        return row;
      });

      doc.autoTable({
        startY: finalY2,
        head: [headersTotales],
        body: bodyTotales,
        styles: { fontSize: 9, cellPadding: 3 },
        headStyles: {
          fontSize: 10,
          fillColor: [240, 240, 240],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          minCellHeight: 10,
        },
        margin: { top: 10, left: 10, right: 10, bottom: 20 },
        didParseCell: function (data) {
          const lastRowIndex = data.table.body.length - 1;

          if (data.section === "body" && data.row.index === lastRowIndex) {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fillColor = [80, 80, 80]; // gris oscuro
            data.cell.styles.textColor = [255, 255, 255]; // blanco
            data.cell.styles.lineWidth = { top: 0.75 }; // borde superior más grueso
            data.cell.styles.lineColor = [0, 0, 0];
          }
        },
      });

      doc.save("ProfitLossHarberLondon.pdf");
    },
    formatMonth(value) {
      const [year, month] = value.split("-");
      const monthNames = [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ];
      return `${monthNames[parseInt(month) - 1]} ${year}`;
    },
    rowClass(item) {
      return "fila-totales-final";
    },
    rowClassConTotal(item, index) {
      if (!item) return "";

      if (item.ultima) {
        return "fila-totales-final";
      }

      return item && !item.isCategoria ? "subfila" : "";
    },
    parseEuro(euroStr) {
      if (!euroStr) return 0;
      return (
        Number(
          euroStr
            .toString()
            .replace(/[^\d,-]+/g, "") // elimina símbolo €
            .replace(/\./g, "") // elimina miles
            .replace(",", ".") // cambia coma decimal
        ) || 0
      );
    },
  },
};
</script>

<style>
.modal-categorias {
  max-height: 90vh;
  overflow-y: auto;
}

.subfila {
  background-color: #f9f9fc; /* fondo suave */
  font-size: 0.95rem;
  color: #4a4a4a;
}

.subfila:hover {
  background-color: #eef1f7; /* al pasar el ratón */
}

.subfila td:first-child {
  padding-left: 3rem !important;
  font-weight: 500;
  position: relative;
}

.subfila td:first-child::before {
  /*content: "•";*/
  position: absolute;
  left: 2rem;
  color: #999;
  font-size: 0.9rem;
}

.toggle-categoria-btn {
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  padding: 2px 6px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.toggle-categoria-btn:hover {
  background-color: #e6e6e6;
}

.thread-categorias tr th {
  background-color: #fff !important;
  font-weight: bold;
}

.fila-totales-final {
  font-weight: bold;
  background-color: #f0f0f0;
  border-top: 2px solid #333;
}
</style>
